/**
 * PaymentLogos — Premium trust-strip with official brand marks.
 *
 * Renders as a horizontal row of monochrome logos (Apple Pay, Google Pay,
 * Visa, Mastercard, Stripe) sized identically and aligned on the same
 * baseline — the look every credible checkout (Stripe Checkout, Shopify,
 * Apple) uses. No wordmark text, no asymmetric heights.
 *
 * Logos are served as SVG from simpleicons.org's free CDN (cdn.simpleicons.org)
 * — these are vector marks pulled from the brands' own brand guidelines and
 * licensed for unrestricted use. Monochrome variant matches the dark-themed
 * checkout cards better than the multi-colour brand versions, which look
 * jarring on coloured backgrounds.
 *
 * Themes:
 *   "gold"  → muted cream (#E8DCC3) for /7days
 *   "amber" → warm gold (#F0E0B0) for /nabd
 *   "rose"  → soft peach (#F0D8CE) for /reply
 */

const SI_BASE = "https://cdn.simpleicons.org";

const THEME_HEX = {
  gold: "E8DCC3",
  amber: "F0E0B0",
  rose: "F0D8CE",
};

// Order matches the visual hierarchy of trust: wallets first (most modern),
// then card schemes, then the processor at the end (lock badge).
const LOGOS = [
  { slug: "applepay", label: "Apple Pay", w: 36 },
  { slug: "googlepay", label: "Google Pay", w: 36 },
  { slug: "visa", label: "Visa", w: 32 },
  { slug: "mastercard", label: "Mastercard", w: 26 },
  { slug: "stripe", label: "Stripe", w: 32 },
];

const PaymentLogos = ({ theme = "gold", testid = "payment-logos" }) => {
  const hex = THEME_HEX[theme] || THEME_HEX.gold;
  return (
    <div
      className="flex items-center justify-center gap-4 py-2.5 px-3 rounded-xl border"
      style={{
        background: "rgba(255,255,255,0.015)",
        borderColor: `rgba(${parseInt(hex.slice(0,2), 16)}, ${parseInt(hex.slice(2,4), 16)}, ${parseInt(hex.slice(4,6), 16)}, 0.22)`,
      }}
      data-testid={testid}
    >
      {LOGOS.map((l) => (
        <img
          key={l.slug}
          src={`${SI_BASE}/${l.slug}/${hex}`}
          alt={l.label}
          width={l.w}
          height={18}
          loading="lazy"
          decoding="async"
          style={{ height: 18, width: "auto", opacity: 0.92 }}
        />
      ))}
    </div>
  );
};

export default PaymentLogos;
